import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import Link from '../Link/Link';

const franchiseColorMap = {
  briefings: 'text-grape-soda',
  life: 'text-oceanText',
  workshop: 'text-campariText',
};

const TitleLabel = ({ color = 'text-slate', franchise, tags }) => {
  const franchiseUrl = franchise?.url;
  const franchiseName = franchise?.name;
  const hasFranchise = franchiseUrl && franchiseName;

  const tagUrl = tags?.[0]?.url;
  const tagName = tags?.[0]?.name;
  const hasTag = tagUrl && tagName;

  const hideTagClasses = classnames(
    { hidden: hasFranchise },
    { 'lg:inline': hasFranchise },
  );
  return (
    <p
      className={classnames(
        'overflow-hidden',
        'uppercase',
        'stink-eyebrow',
        'uppercase',
        color,
        'overflow-ellipsis',
        'whitespace-nowrap',
      )}
    >
      {hasFranchise && (
        <Link
          className={classnames(
            franchiseColorMap[franchiseName.toLowerCase()],
            'uppercase',
            'stink-eyebrow',
          )}
          to={franchiseUrl}
        >
          {franchiseName}
        </Link>
      )}
      {hasFranchise && hasTag && (
        <span className={classnames(color, hideTagClasses)}> • </span>
      )}
      {hasTag && (
        <Link
          className={classnames(
            'uppercase',
            color,
            'stink-eyebrow',
            hideTagClasses,
          )}
          to={tagUrl}
        >
          {tagName}
        </Link>
      )}
    </p>
  );
};

TitleLabel.propTypes = {
  color: PropTypes.string,
  franchise: PropTypes.object,
  tags: PropTypes.array,
};

export default TitleLabel;
